export default {
  procedureChoice(procedureChoice) {
    switch (procedureChoice) {
      case 'NEW': return 'Nuova Fidelity'
      case 'UPDATE': return 'Aggiornamento'
      case 'ADMIN_UPDATE': return 'Aggiornamento'
      case 'REISSUE': return 'Riemissione'
      case 'HIDE': return 'Oblio'
    }
  },
  dataEntryMode(dataEntryMode) {
    switch (dataEntryMode) {
      case 'CIE':
        return "Dao Fidelity App con CIE"
      case 'CNS':
        return "Dao Fidelity App con CNS"
      case 'MANUAL':
        return "Dao Fidelity App Manuale";
      case 'DIGITALIZED_MANUAL':
        return "Nuova Digitalizzazione";
      case 'DIGITALIZED_MORE':
        return "Digitalizzazione Pregresso";
      case 'DIGITALIZED_MORE_MODIFIED':
        return "Digitalizzazione Pregresso con Modifica";
      case 'WEB_CONAD':
        return "Web App Conad";
    }
  },
  translateHistory(value) {
    switch (value) {
      case 'barcode':
        return 'Codice Tessera'
      case 'shopCode':
        return 'Codice Negozio'
      case 'shopName':
        return 'Nome Negozio'
      case 'firstName':
        return 'Nome'
      case 'lastName':
        return 'Cognome'
      case 'gender':
        return 'Sesso'
      case 'birthDate':
        return 'Data di Nascita'
      case 'birthPlace':
        return 'Luogo di Nascita'
      case 'residence':
        return 'Indirizzo di residenza'
      case 'fiscalCode':
        return 'Codice Fiscale'
      case 'email':
        return 'Email'
      case 'mobilePhone':
        return 'Cellulare'
      case 'telephone':
        return 'Telefono Fisso'
      case 'familyNumber':
        return 'Numero componenti famigliari'
      case 'partnerLastName':
        return 'Cognome del partner'
      case 'firstChildBirthDate':
        return 'Data di Nascita Primo Figlio'
      case 'secondChildBirthDate':
        return 'Data di Nascita Secondo Figlio'
      case 'thirdChildBirthDate':
        return 'Data di Nascita Terzo Figlio'
      case 'marketingConsensus':
        return 'Consenso Marketing'
      case 'profilingConsensus':
        return 'Consenso Profilazione'
      case 'cooperativesConsensus':
        return 'Consenso Cooperative'
      case 'thirdPartyConsensus':
        return 'Consenso Terze Parti'
      case 'source':
        return 'Fonte'
      case 'demandType':
        return 'Tipo Operazione'
      case 'NEW':
        return 'Nuova Attivazione'
      case 'UPDATE':
        return 'Modifica dei Dati'
      case 'REISSUE':
        return 'Sostituzione Tessera'
      case 'FIX':
        return 'Correzione Dati'
      case 'agreementId':
        return 'Documento'
      case true:
        return 'Si'
      case false:
        return 'No'
      case 'Web':
        return 'Conad'
      case 'Cherry':
        return 'DAO'
      default:
        return value
    }
  }
}


